function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "dlhxdw.tif"
}, React.createElement("g", null, React.createElement("path", {
  d: "M11.4,23.1c0,22.2,0,43.7,0,65.4c21.7,0,43.2,0,65.5,0c0-6.1,0-12.4,0-18.6c0-3.1-0.5-6.4,0.2-9.4 c0.4-1.7,2.6-4.1,4.1-4.2c1.5-0.1,4.3,2.4,4.4,3.8c0.4,9.6,0.4,19.2,0,28.8c-0.2,5.2-3.9,8.6-9.2,8.6c-21.5,0.2-43.1,0.2-64.6,0 c-5.7,0-9.3-3.8-9.3-9.6c-0.2-21.4-0.2-42.8,0-64.1c0-6,3.8-9.4,9.9-9.6c8.8-0.2,17.6,0,26.3-0.1c3.1,0,5.3,0.9,5.3,4.4 c0,3.5-2.2,4.5-5.2,4.5C29.8,23.1,20.8,23.1,11.4,23.1z"
}), React.createElement("path", {
  d: "M85.4,21.4C68,39,50.6,56.6,32.5,74.8c-2.4-2.6-4.4-4.8-6.4-6.9c17.9-17.7,35.4-35.1,53-52.5c-0.4-0.5-0.8-1-1.1-1.5 c-3.5,0-7-0.2-10.4,0.1c-3.6,0.2-5.7-0.7-5.7-4.8c0-3.8,0-7,5.3-6.8c8.4,0.3,16.9,0.2,25.3,0c3.6-0.1,5.2,1.3,5.1,4.9 c-0.1,8.6-0.2,17.2,0,25.8c0.1,5-2.9,4.9-6.5,5c-4.1,0.1-5.3-1.8-5-5.5c0.3-3.5,0.4-6.9,0.6-10.4C86.3,22,85.9,21.7,85.4,21.4z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      "enableBackground": "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/link.69d91db9.svg";
export { SvgComponent as ReactComponent };